'use client';
import { getSelectedProductKey } from '@/constants';
import { UserCurrent } from '@/services/personal-center/types';

/**
 * 保存用户profile到localStorage
 * @param profile 用户profile对象
 */
export const storeProfile = (profile: UserCurrent): void => {
    localStorage.setItem('profile', JSON.stringify(profile));
};

/**
 * 从localStorage获取用户profile
 * @returns 用户profile对象或null
 */
export const getProfile = (): UserCurrent | null => {
    const profileStr = localStorage.getItem('profile');
    if (!profileStr) return null;
    try {
        return JSON.parse(profileStr) as UserCurrent;
    } catch (error) {
        console.error('Failed to parse profile:', error);
        return null;
    }
};

/**
 * 清除用户profile
 */
export const clearProfile = (): void => {
    localStorage.removeItem(getSelectedProductKey());
    localStorage.removeItem('profile');
};
